module.exports = __webpack_public_path__ + "static/art5-1b495719ad46032bbbd58f469387e0e2.png";